import {
  BasePageModel,
  basePageToLocal,
  DiffStates,
  Reference,
  ReferenceNode
} from '@interface/index';

export interface ValueAssociation extends BasePageModel {
  variable: Reference;
  defaultValues: Reference[];
  variableType: string;
}

export function valueAssociationToLocal(data: any): ValueAssociation {

  return {
    ...basePageToLocal(data),
    variable: data.variable.map((node: any) => ({
      id: node.id,
      name: node.name,
      type: node.type
    })),
    variableType: data.variable_type,
    defaultValues: (data.default_values || []).map((value: any[]) =>
      (value || []).map((node: any) => ({
        id: node.id,
        name: node.name,
        type: node.type
      }))
    )
  };
}

export function valueAssociationToServer(data: ValueAssociation) {
  return {
    id: data.id,
    variable: data.variable.map((node: any) => ({
      id: node.id,
      name: node.name,
      type: node.type
    })),
    variable_type: data.variableType,
    default_values: (data.defaultValues || []).map((value: Reference) =>
      (value || []).map((node: ReferenceNode) => ({
        id: node.id,
        name: node.name,
        type: node.type
      }))
    ),
    inherited_from_composite_id: data.inheritedFromCompositeId
  };
}
